import { render, staticRenderFns } from "./OrdersDeliveriesOverview.vue?vue&type=template&id=2d3cc4dc&"
import script from "./OrdersDeliveriesOverview.vue?vue&type=script&lang=js&"
export * from "./OrdersDeliveriesOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports